/** Full locale zh (Simplified Chinese) – edit as needed. */
export default {
  'nav.home': '首页',
  'nav.seeDemo': '观看演示',
  'nav.howItWorks': '如何运作',
  'nav.pricing': '定价',
  'nav.aboutUs': '关于我们',
  'nav.faqs': '常见问题',
  'nav.contact': '联系我们',
  'nav.careers': '招聘',
  'nav.blog': '博客',
  'nav.logIn': '登录 / 注册',
  'nav.getStarted': '开始使用',
  'brand.primeDocumentSign': 'Prime Document Sign',
  'hero.priceBanner': '每月仅需 2 美元起！',
  'hero.subscriptionsOnly': '( 仅订阅制 )',
  'hero.couponBannerText': '前1000名用户专享终身10%折扣优惠码！',
  'hero.couponSubscribedOnly': '(仅订阅用户)',
  'hero.couponCode': '25OFFNEWUSERS1000',
  'hero.bannerEyebrow': '电子签名平台 · 套餐每月 2 美元起',
  'hero.bannerHeadlinePrefix': '「',
  'hero.bannerHeadlineMid': '」即时签署完成。',
  'hero.bannerHeadlineAccent': '',
  'hero.bannerCycleContracts': '合同',
  'hero.bannerCycleNDAs': '保密协议',
  'hero.bannerCycleProposals': '提案',
  'hero.bannerCycleDocuments': '文档',
  'hero.bannerDesc':
    '创建专业协议，发送电子签名，并在几分钟内收到具有法律效力的已签 PDF——可在任何设备上操作。',
  'hero.watchDemo': '了解使用方式',
  'hero.trustLocked': 'AES-256 加密',
  'hero.trustNoCard': '无需银行卡',
  'hero.trustReady': '约 2 分钟即可上手',
  'hero.landingShowMore': '展开',
  'hero.landingShowLess': '收起',
  'hero.tagline': '创建、签署和发送文档的最简单方式 — 无合约束缚',
  'hero.firebaseTopAria': '安全与托管（Google Firebase 与 Google Cloud）',
  'hero.topTrustListAria': '安全、定价、签署、提醒与支持',
  'hero.accDataSafeTitle': '您的数据由我们妥善守护',
  'hero.accDataSafe1':
    '基于 Google Firebase 与 Google Cloud——全球数百万应用信赖的企业级基础设施',
  'hero.accDataSafe2': '采用 Google 托管密钥的 AES-256 静态加密保护数据',
  'hero.accDataSafe3': '身份验证与数据处理遵循 Google 领先的安全标准',
  'hero.accDataSafe4': '从不出售或共享您的数据，始终尊重隐私',
  'hero.accDataSafe5Before': '清晰说明数据如何存储与使用（请参阅我们的',
  'hero.accDataSafe5After': '）',
  'hero.accPricingTitle': '简单透明定价 · 无隐藏费用',
  'hero.accPricing1': '几分钟内创建专业协议',
  'hero.accPricing2': '套餐每月仅需 2 美元起',
  'hero.accPricing3': '无隐藏费用或意外扣款',
  'hero.accPricing4': '无合约束缚 · 随时取消',
  'hero.accPricing5': '适合自由职业者、初创与小企业',
  'hero.accPricing6': '首份文档可免费发送',
  'hero.accSigningTitle': '快速简便的电子签署',
  'hero.accSigning1': '30 种以上模板或上传自有文件',
  'hero.accSigning2': '数秒内添加签名字段并完成定制',
  'hero.accSigning3': '同时发送给多位收件人',
  'hero.accSigning4': '保存模板以便重复使用',
  'hero.accSigning5': '收件人无需注册即可即时签署',
  'hero.accSigning6': '发送前实时预览确保无误',
  'hero.accRemindersTitle': '智能提醒与跟踪',
  'hero.accReminders1': '第 1、3、7 天自动跟进提醒',
  'hero.accReminders2': '文档被打开或签署时即时通知',
  'hero.accReminders3': '实时跟踪整个签署流程',
  'hero.accReminders4': '告别手动催签',
  'hero.accAnywhereTitle': '随时随地办公',
  'hero.accAnywhere1': '在电脑或手机上访问文档',
  'hero.accAnywhere2': '任何设备均可发送与签署',
  'hero.accAnywhere3': '无论办公室或外出都同样灵活',
  'hero.accSupportTitle': '可靠支持',
  'hero.accSupport1': '专业客服团队，响应迅速',
  'hero.accSupport2': '力争 24 小时内回复',
  'hero.accSupport3': '根据用户反馈持续更新改进',
  'hero.firebaseTrustPrivacyLink': '隐私政策',
  'hero.firebaseTrustFineprintAfter':
    ' 说明了数据保留、访问方式及您的权利。我们绝不会出售您的数据。',
  'hero.pill': '几秒钟内发送具有法律效力的电子签名',
  'hero.headline': '面向自由职业者和小团队的最简单电子签名工具',
  'hero.ctaPrimary': '创建 / 上传文档并发送签署',
  'hero.ctaTrialSignup': '立即开始免费试用',
  'hero.ctaFreeDocument': '立即开始免费试用',
  'hero.ctaPrimaryNote': '免费7天。需要银行卡。之后每年35美元，除非取消。',
  'hero.subscriptionTeaserBefore': '订阅每月仅需 ',
  'hero.subscriptionTeaserAfter': '！',
  'hero.createAccountTrialHeadline': '开始7天免费试用',
  'hero.createAccountPromoCopy': '复制优惠码',
  'hero.createAccountPromoCopied': '已复制！',
  'hero.createAccountPromoCodeAria': '促销码：一个月免费试用',
  'hero.createAccountNote': '选择套餐时在结账页面使用。',
  'hero.createAccountOfferLimit': '（ 优惠仅限前 1000 名用户 ）',
  'hero.desc': '以现代签署体验创建、发送和跟踪协议。',
  'hero.getStartedFree': '免费开始',
  'hero.tryWithoutAccountButton': '无需账户即可试用',
  'hero.logInSignUp': '登录 / 注册',
  'hero.whyChooseUs': '为什么选择我们？',
  'hero.stepsTitle': '创建、签署、接收',
  'hero.stepsSubtitle': '三个简单步骤，几分钟内即可创建并签署文档。',
  'hero.step1Create': '上传或创建您的文档',
  'hero.step2Sign': '发送以获取签名',
  'hero.step3Receive': '签署后即时收到通知',
  'hero.benefit1': '易用 – 几秒钟内发送签名链接和邮件',
  'hero.benefit2': '上传现有 PDF 或提取文本并用富文本编辑',
  'hero.benefit3': '从 PDF 提取文本并编辑',
  'hero.benefit4': '几秒钟内创建签名栏和版式',
  'hero.benefit5': '同时发送给多位收件人',
  'hero.benefit7': '复制链接发送给任何人',
  'hero.benefit8': '创建并保存模板',
  'hero.benefit9': '查看所有邮件动态',
  'hero.benefit10': '实时预览与可审计 PDF',
  'hero.benefit11': '可灵活编辑的模板',
  'hero.benefit12': '收件人无需注册',
  'hero.benefit13': '支持任意设备',
  'how.simpleProcess': '简单流程',
  'how.title': '如何运作',
  'how.subtitle': '三步完成创建、发送与签署。',
  'how.step1Title': '创建模板',
  'how.step1Desc': '提取或上传 PDF、富文本编辑、签名栏（日期、姓名、条款、签名块）、自定义版式。保存为模板并重复使用。',
  'how.step2Title': '发送给收件人',
  'how.step2Desc': '通过邮件发送文档，附带安全唯一签署链接。可添加多位收件人、复制链接、跟踪打开与完成情况。',
  'how.step3Title': '收取已签署 PDF',
  'how.step3Desc': '收到带完整审计记录的已签署 PDF：时间戳、邮箱、电话、同意状态。签署完成后收到确认邮件。',
  'pricing.compareHeadline': '为什么每月花 19 美元买电子签名？',
  'pricing.comparePlatform': '平台',
  'pricing.comparePrice': '价格',
  'pricing.compareUs': 'Prime Document Sign',
  'pricing.compareDocuSign': 'DocuSign',
  'pricing.compareDropboxSign': 'Dropbox Sign',
  'pricing.comparePandaDoc': 'PandaDoc',
  'pricing.comparePerMonth': '{price}/月',
  'pricing.compareBestValue': '最超值',
  'pricing.compareWhyPayLine1': '数秒内发送具有法律约束力的电子签名',
  'pricing.compareWhyPayLine2': '需要发送多份？订阅每月低至 2 美元',
  'pricing.compareBenefitSingle': '发送单份文件',
  'pricing.compareBenefitNoContract': '无昂贵合约',
  'pricing.compareBenefitPayWhenNeed': '按需付费',
  'pricing.compareBenefitTemplates': '从30种以上模板中选择',
  'pricing.compareDisclaimer': '竞争对手价格基于公开的入门计划，可能有所变动。',
  'trust.secureLinks': '每份文档都有唯一安全的签署链接',
  'trust.auditTrail': '每笔签名都有完整审计记录（谁、何时、IP）',
  'trust.verifiablePdfs': '可验证的已签署 PDF 可长期保存',
  'trust.footer': '深受全球自由职业者和小企业信赖',
  'useCases.title': '适用于 ( 模板就绪 )',
  'useCases.freelancers': '发送合同的自由职业者',
  'useCases.agencies': '签署协议的代理机构',
  'useCases.landlords': '发送租约的房东',
  'useCases.startups': '签署保密协议的新创公司',
  'useCases.carBoat': '用法律文件出售汽车或船只',
  'useCases.consultants': '顾问与独立工作者',
  'useCases.equipmentRental': '以正式协议租赁设备',
  'useCases.contractors': '独立承包商签订客户工作协议',
  'useCases.website': '网站与数字项目协议',
  'pricing.title': '定价',
  'pricing.billAnnually': '按年计费',
  'pricing.billMonthly': '按月计费',
  'pricing.getStarted': '开始使用',
  'pricing.mostPopular': '最受欢迎',
  'pricing.billedPerYear': '${amount}/年',
  'pricing.perMonth': '/月',
  'pricing.tierBasic': '基础版',
  'pricing.tierStandard': '标准版',
  'pricing.tierPremium': '高级版',
  'pricing.descBasic': '适合偶尔使用。',
  'pricing.descStandard': '适合成长型团队。',
  'pricing.descPremium': '适合有进阶需求的用户。',
  'about.label': '为什么选择我们',
  'about.title': '关于我们',
  'about.subtitle': '让签署流程简单、快速、安全。',
  'about.speed': '速度',
  'about.builtForSpeed': '为速度而设计',
  'about.builtForSpeedDesc': '现代界面，几分钟内创建并发送文档。签署方可从任意设备完成协议。',
  'about.security': '安全',
  'about.dataSecurity': '数据安全',
  'about.dataSecurityTitle': '托管于 Google Firebase 与 Google Cloud',
  'about.dataSecurityDesc': '您的账户数据、文档、模板与签署活动均在 Google Firebase 与 Google Cloud 上处理；这些平台面向需要强身份验证与存储的生产级应用。流量端到端使用 HTTPS（TLS）；静态数据使用 Google 托管密钥（含 AES-256）加密。登录流程使用 Firebase Authentication，Firestore 安全规则有助于确保读写与您的账户匹配，从而使工作区保持隔离、不会公开可读。服务运行在 Google 全球网络上，遵循其文档中的监控、补丁与可靠性实践；我们不会向经纪商或广告商出售您的个人数据或文档内容。有关子处理者、合规计划及您的权利，请参阅我们的隐私政策。',
  'about.dataSecurityPrivacyCta': '阅读完整隐私政策 →',
  'about.privacyPill': '隐私',
  'about.privacyFocused': '注重隐私',
  'about.privacyFocusedDesc': '每条签署链接都是唯一的，收件人只会看到您发送的内容。已签署的 PDF 带有清晰的审计追踪可供归档：谁签署、何时签署以及给予的同意，使隐私与证明相统一。',
  'about.teams': '个人与团队',
  'about.madeForTeams': '面向个人与团队',
  'about.madeForTeamsDesc': '无论独自签署还是团队协作，模板都能简化流程。支持富文本、标题、列表、签名栏、日期、姓名及自定义栏。保存模板并可随时从模板历史加载。',
  'about.sectionHeadlineBefore': '为信任与速度 ',
  'about.sectionHeadlineAccent': '而打造',
  'about.firebaseVisualBadge': 'Google Firebase · Google Cloud',
  'faq.title': '常见问题',
  'faq.searchHint': '输入关键词快速查找 FAQs',
  'faq.searchPlaceholder': '例如：PDF、模板、签名...',
  'faq.noResults': '没有找到匹配的 FAQ。请尝试其他关键词。',
  'faq.more': '更多',
  'faq.less': '收起',
  'faq.eyebrow': '有疑问？',
  'faq.titleBefore': '常见',
  'faq.titleAccent': '问题',
  'faq.subtitleLead': '关于 Prime Document Sign 您需要了解的一切。找不到答案？ ',
  'faq.subtitleLink': '联系我们。',
  'faq.clearSearchAria': '清除搜索',
  'faq.subscriptionsWorkQ': '订阅如何计费？',
  'faq.upgradePlanQ': '如何升级计划？',
  'faq.upgradePlanA': '进入 我的账户 → 我的订阅，选择更高档位并确认。升级通常立即生效。',
  'faq.downgradePlanQ': '如何降级？',
  'faq.downgradePlanA': '进入 我的账户 → 我的订阅，选择较低档位并确认。降级在下一计费周期开始时生效。',
  'faq.cancelPlanQ': '如何取消订阅？',
  'faq.cancelPlanA': '进入 我的账户 → 我的订阅，通过 Stripe 客户门户取消或联系支持。取消在当期结束后生效。',
  'faq.emailLimitQ': '达到月度邮件上限会怎样？',
  'faq.emailLimitA': '基础版 5 封/月，标准版 100，高级版 300。每月初重置。达限后可购买额外或升级计划。',
  'faq.yearlyBillingQ': '支持按年计费吗？',
  'faq.yearlyBillingA': '支持。高级版可选月付或年付：${{monthly}} 美元/月或 ${{annual}} 美元/年。年付可比月付节省最多 {{discountPercent}}%。可在 我的订阅 中切换。',
  'faq.multipleRecipientsQ': '可以发给多人吗？',
  'faq.multipleRecipientsA': '可以。基础版最多 5 人/次，标准版与高级版最多 10 人。输入邮箱以逗号分隔。每人获得唯一签署链接，无需账户。',
  'faq.reuseTemplatesQ': '可以重复使用模板吗？',
  'faq.reuseTemplatesA': '基础版 3 个、标准版 10 个、高级版 25 个已保存模板。在 我的账户 的模板历史中随时加载。',
  'faq.recipientAccountQ': '收件人需要账户吗？',
  'faq.recipientAccountA': '不需要。收件人收到邮件中的链接即可在设备上直接签署。支持电脑、平板和手机。',
  'faq.confirmationEmailQ': '会收到确认邮件吗？',
  'faq.confirmationEmailA': '会。文档完成后会自动发送确认邮件并附带已签署 PDF。每份 PDF 含可验证审计记录。',
  'faq.previewPdfQ': '发送前可以预览 PDF 吗？',
  'faq.previewPdfA': '可以。使用“预览 PDF”按钮查看版式后再发送或复制链接。',
  'faq.editAgreementQ': '可以编辑协议正文吗？',
  'faq.editAgreementA': '可以。使用富文本编辑器添加标题、列表、粗体、斜体、下划线等。也可上传 PDF 提取或展示全文。',
  'faq.signatureRequiredQ': '提交必须签名吗？',
  'faq.signatureRequiredA': '是。收件人须填写日期、全名、条款勾选和签名后方可提交。以满足法律效力要求。',
  'faq.attachmentsQ': '可以附带多少附件？',
  'faq.attachmentsA': '基础版不支持附件。标准版每封邮件最多 3 个（共 8 MB）。高级版最多 10 个（共 8 MB）。附件随签署链接一并发送。',
  'faq.emailActivityQ': '邮件活动与限额（高级版）是什么？',
  'faq.emailActivityA': '高级版包含邮件活动与限额。在 我的账户 中查看发送记录：文档、时间与收件人。便于合规与留档。',
  'faq.emailRemindersQ': '邮件提醒如何工作？',
  'faq.emailRemindersA': '在文档构建器第 4 步（附加功能）中，您可以为每次发送开启 1 天、3 天和/或 7 天提醒。首次签署邮件发出后，仅当该收件人尚未完成文档时我们才会发送提醒。对方签署后提醒会自动停止。提醒邮件会显示在邮件活动中并带日期时间；不计入每月邮件发送额度。',
  'faq.defaultSenderQ': '可以设置默认发件邮箱吗？',
  'faq.defaultSenderA': '可以。进入 我的账户 → 账户详情，在默认邮箱栏填写并保存。发送时会自动填入。',
  'faq.mobileSignQ': '收件人可以在手机上签署吗？',
  'faq.mobileSignA': '可以。签署体验支持响应式。可在手机或平板上打开链接，用手指或触控笔签名。',
  'faq.getHelpQ': '如何获取帮助？',
  'faq.getHelpA': '在 我的账户 中联系支持或使用网站联系表单。我们会尽快回复。',
  'faq.dataSecureQ': '数据安全吗？',
  'faq.dataSecureA': '是。我们采用行业标准保护您的文档与个人信息。传输与存储均加密。',
  'faq.fileFormatsQ': '支持哪些文件格式？',
  'faq.fileFormatsA': '文档在富文本编辑器中创建。已完成协议以 PDF 生成，适用于法律与商务。',
  'faq.deleteTemplateQ': '删除模板会怎样？',
  'faq.deleteTemplateA': '删除后无法恢复。删除前请确认不再需要。可随时从当前文档新建模板。',
  'faq.ownLogoQ': '可以添加自己的 logo 吗？',
  'faq.ownLogoA': '可以，在标准版与高级版中。上传 logo（最大 20 KB）并选择位置。基础版不包含。',
  'faq.uploadPdfQ': '如何上传 PDF？',
  'faq.uploadPdfA': '在文档构建器中，使用“上传 PDF”选项（标准版和高级版）。PDF 会显示在协议文本上方或旁边。收件人签署时可看到完整文档。',
  'faq.extractPdfQ': '什么是 PDF 提取？如何工作？',
  'faq.extractPdfA': 'PDF 提取（标准版和高级版）可将现有 PDF 的文本提取到富文本编辑器中编辑。上传 PDF，选择“提取文本”，内容会复制到编辑器。然后可修改并添加签名字段。',
  'faq.richTextEditorQ': '富文本编辑器可以做什么？',
  'faq.richTextEditorA': '富文本编辑器可创建和格式化协议：标题、粗体、斜体、列表、字号。在下方添加签名块。无需编码，全部点击即可完成。',
  'faq.previewWhenQ': '发送前何时应预览？',
  'faq.previewWhenA': '发送前务必使用“预览 PDF”。它会显示收件人将看到的准确布局：协议文本、签名块、日期、姓名。检查格式后发送或复制链接。',
  'faq.documentLifetimeQ': '签署链接有效期多久？可以申请延期吗？',
  'faq.documentLifetimeA': '签署链接通常自创建之日起约 30 天内有效。请在链接过期前下载并保存已签署的 PDF。若链接已过期，请联系发送方索取带新链接的邮件。',
  'faq.editLayoutQ': '如何编辑签名布局？',
  'faq.editLayoutA': '在签名区域使用“编辑布局”可重新排列字段。拖放日期、全名、条款、签名块和自定义字段。可添加间距并选择列数。',
  'faq.customFieldsQ': '如何添加自定义字段（文本、日期、复选框等）？',
  'faq.customFieldsA': '在签名区域点击“添加自定义字段”。选择标签和类型：文本、数字、日期、时间、列表、复选框或签名。每份文档最多 10 个自定义字段。勾选哪些签署人可见各字段，然后用“编辑布局”定位。',
  'faq.multipleSignaturesQ': '可以添加 2 个或更多签名（多位签署人）吗？',
  'faq.multipleSignaturesA': '可以。在“收件人”区域添加第二位签署人。每人获得唯一链接和自己的签名块。基础版每次最多 5 人；标准版和高级版最多 10 人。',
  'faq.documentBuilderTipsQ': '文档构建器可以做什么？',
  'faq.documentBuilderTipsA': '创建协议、上传或提取 PDF、添加签名块、自定义字段和附件。使用编辑布局、保存模板、预览 PDF。所有更改会自动保存。',
  'faq.clearEverythingQ': '“全部清除”有什么作用？',
  'faq.clearEverythingA': '“全部清除”会重置文档构建器：删除协议文本、签名块、自定义字段和附件。用于从头开始新文档。已保存的模板不受影响。',
  'faq.forgotPasswordQ': '我忘记了密码。如何重置？',
  'faq.forgotPasswordA': '在登录界面点击“忘记密码？”。输入账户邮箱并发送重置链接。检查收件箱（和垃圾邮件）。链接会过期—如需要可申请新链接。使用新密码登录。',
  'faq.saveTemplateQ': '如何将文档保存为模板？',
  'faq.saveTemplateA': '创建文档后，点击“保存模板”。输入名称并选择“另存为新”。会出现在“我的账户”的模板历史中。更新时：加载模板、修改，然后“保存模板”→“更新模板”。',
  'faq.loadTemplateQ': '如何从模板历史加载模板？',
  'faq.loadTemplateA': '进入“我的账户”→“模板历史”。点击要加载的模板。会在构建器中打开，包含完整内容和布局。按需编辑、添加收件人并发送。',
  'faq.templateLimitsQ': '可以保存多少个模板？',
  'faq.templateLimitsA': '基础版：3 个，标准版：10 个，高级版：25 个。每个模板保存文本、格式、签名块和布局。达到上限时：删除旧模板或升级计划。',
  'faq.recipientNoEmailQ': '收件人未收到签署邮件怎么办？',
  'faq.recipientNoEmailA': '请其检查垃圾邮件。使用“复制链接”获取 URL 并手动分享（短信、Slack 等）。或将文档重新发送至同一邮箱以获取新链接。',
  'faq.editAfterSendQ': '发送后可以编辑文档吗？',
  'faq.editAfterSendA': '不可以。发送后内容会被锁定。如需修改：创建包含更新内容的新文档并重新发送。未发送的草稿可自由编辑。',
  'faq.changeAccountQ': '如何更改账户邮箱或密码？',
  'faq.changeAccountA': '进入“我的账户”→“账户详情”。更新邮箱或密码。修改密码时：输入当前密码和新密码。如忘记当前密码，请在登录界面使用“忘记密码？”。',
  'faq.browserSupportQ': '支持哪些浏览器和设备？',
  'faq.browserSupportA': 'Chrome、Firefox、Safari、Edge（桌面和移动端）。签署支持响应式—可在智能手机和平板上使用。建议使用最新版浏览器。无需下载应用。',
  'faq.copyLinkQ': '如何复制链接分享而不是发送邮件？',
  'faq.copyLinkA': '创建文档后，点击“复制链接”。URL 会复制到剪贴板。粘贴到消息、邮件或 Slack 中。收件人无需收到我们的邮件即可签署。',
  'faq.resendDocumentQ': '收件人尚未签署时，可以重新发送文档吗？',
  'faq.resendDocumentA': '可以。可将同一文档再次发送至相同或不同邮箱。每次发送会生成新链接。若原链接已过期，重新发送会提供新链接。可使用邮件活动（高级版）追踪发送状态。',
  'testimonials.eyebrow': '客户评价',
  'testimonials.title': '客户怎么说。',
  'testimonials.quote1': '价格最实惠。对比了几款工具，这款性价比高且易用。',
  'testimonials.quote2': '从 ChatGPT 复制协议，几分钟内编辑并发送签署，不到 10 分钟完成。',
  'testimonials.quote3': '全程在手机上完成：建文档、加签名栏、通勤时发送。',
  'testimonials.quote4': '简单好用、价格公道、无隐藏费用。团队用来签合同和 NDA。',
  'testimonials.quote5': '粘贴合同内容、放入签名块、发送，当天就签完。',
  'testimonials.quote6': '在笔记本和手机上都用过，体验流畅。电子签名里最划算。',
  'testimonials.prev': '上一页',
  'testimonials.next': '下一页',
  'contact.title': '联系我们',
  'contact.subtitle': '有问题？我们很乐意听取您的意见。',
  'contact.eyebrow': '联系我们',
  'contact.headlineBefore': '欢迎 ',
  'contact.headlineAccent': '沟通',
  'contact.responseTimeLabel': '回复时间',
  'contact.responseTimeValue': '24 小时内',
  'contact.secureLabel': '安全私密',
  'contact.secureValue': 'AES-256 加密',
  'contact.trustNoSpam': '绝不发送垃圾邮件',
  'contact.trustHumanSupport': '真人客服支持',
  'contact.firstName': '名',
  'contact.lastName': '姓',
  'contact.email': '邮箱',
  'contact.message': '留言',
  'contact.sendMessage': '发送',
  'contact.required': '*',
  'contact.placeholderFirst': '请输入名',
  'contact.placeholderLast': '请输入姓',
  'contact.placeholderEmail': '请输入邮箱',
  'contact.placeholderMessage': '告诉我们您需要什么帮助…',
  'contact.attachments': '附件',
  'contact.attachmentsHint': '最多 5 个文件，共 2 MB',
  'contact.addFiles': '+ 添加文件',
  'contact.addAttachmentsAria': '添加附件',
  'auth.forgotPassword': '忘记密码？',
  'auth.backToLogIn': '返回登录',
  'auth.sendResetLink': '发送重置链接',
  'auth.checkEmailReset': '请查收邮件中的重置链接。',
  'auth.emailLabel': '邮箱',
  'auth.passwordLabel': '密码',
  'auth.firstNameLabel': '名',
  'auth.lastNameLabel': '姓',
  'auth.enterEmail': '请输入邮箱。',
  'auth.enterEmailPassword': '请输入邮箱和密码。',
  'auth.passwordMinLength': '密码至少 8 位。',
  'auth.passwordSpecial': '密码须含特殊字符。',
  'auth.passwordsNoMatch': '两次密码不一致。',
  'auth.signInWithGoogle': '使用 Google 登录',
  'auth.or': '或',
  'auth.logInFailed': '登录失败。',
  'auth.signUpFailed': '注册失败。',
  'auth.emailAlreadyInUse': '该邮箱已被使用。',
  'connectionError.message': '连接出现问题。请检查网络连接并刷新页面。',
  'connectionError.refresh': '刷新页面',
  'connectionError.tooManyRequests': '尝试次数过多，请稍后再试。',
  'auth.emailPlaceholder': 'name@example.com',
  'auth.passwordPlaceholder': '请输入密码',
  'auth.firstNamePlaceholder': '名',
  'auth.lastNamePlaceholder': '姓',
  'auth.manageSubscription': '管理订阅',
  'auth.subscribe': '订阅',
  'auth.signUpForSubscription': '注册订阅',
  'auth.currentPlan': '当前计划',
  'auth.updatePlanHint': '在 Stripe 中升级以获得更多月度额度。',
  'auth.updatePlanStripe': '在 Stripe 安全门户中更新计划、支付方式或取消。',
  'auth.subscribeToPlan': '订阅计划即可开始使用。',
  'auth.topUpCredits': '购买额度（{{label}}：${{price}}）',
  'pricing.featureRecipients5': '每次最多 5 位收件人',
  'pricing.featureRecipients10': '每次最多 10 位收件人',
  'pricing.featureEmails5': '每月最多 5 封邮件',
  'pricing.featureEmails50': '每月最多 100 封邮件',
  'pricing.featureEmails150': '每月最多 300 封邮件',
  'pricing.featureTemplates3': '3 个已保存模板',
  'pricing.featureTemplates10': '10 个已保存模板',
  'pricing.featureTemplates25': '25 个已保存模板',
  'pricing.featureChars3k': '3,000 字符限制',
  'pricing.featureChars20k': '20,000 字符限制',
  'pricing.featureChars30k': '30,000 字符限制',
  'pricing.featureAttachmentsNone': '无额外附件',
  'pricing.featureAttachments3': '3 个附件（共 8 MB）',
  'pricing.featureAttachments10': '10 个附件（共 8 MB）',
  'pricing.featurePdfUpload': '完整 PDF 上传',
  'pricing.featureAuditTrail': '完整审计记录',
  'pricing.featurePdfExtract': 'PDF 文本提取与编辑',
  'pricing.featureCustomFields': '自定义栏与版式',
  'pricing.featureCopyLink': '复制签署链接',
  'pricing.featureLogo': '上传自定义 logo',
  'pricing.featureVerification': '收件人验证',
  'app.createYourDocument': '创建您的文档',
  'app.backToApp': '返回应用',
  'app.backToMainSite': '返回主站',
  'app.backShort': '返回',
  'app.myAccount': '我的账户',
  'app.saveTemplate': '保存模板',
  'app.templatesUsed': '已用模板',
  'app.templatesUsedSaved': '已保存 {{count}} 个模板',
  'app.startFromTemplate': '从模板开始',
  'app.startFromTemplateHint': '选择模板以填写文档。选择后可进行编辑。',
  'app.signedInAs': '当前登录为',
  'app.sendCredits': '发送额度',
  'app.freeSendBanner': '您有 1 次免费邮件发送 — 可用于发送文档以供签署。随时订阅以获得更多。',
  'app.creditEqualsSend': '1 额度 = 1 次邮件发送',
  'app.topUpCredits': '购买额度',
  'app.emailSends': '次邮件发送',
  'app.signedAgreements': '份已签署协议',
  'app.usedAfterAllowance': '（超出月度额度后使用）',
  'app.sendForSignature': '发送签署',
  'app.recipientsSection': '发送至',
  'app.fromNameOrg': '发件人姓名 / 机构',
  'app.fromNamePlaceholder': '您的姓名或机构名称',
  'app.fromEmail': '发件人邮箱',
  'app.fromEmailPlaceholder': '发件人邮箱地址',
  'app.recipientEmail': '收件人邮箱',
  'app.recipientHint': '逗号分隔，最多 {{max}} 位收件人',
  'app.recipientPlaceholder': '收件人邮箱地址',
  'app.recipientTooltip': '示例：a@b.com, c@d.com, e@f.com',
  'app.previewPdf': '预览 PDF',
  'app.clearEverything': '清空全部',
  'app.clearEverythingTitle': '清空文档、收件人和已保存草稿',
  'app.copyLink': '复制链接',
  'app.copyLinkSubscribersOnly': '复制链接（仅订阅用户）',
  'app.generatingLink': '正在生成链接…',
  'app.sendEmail': '发送邮件',
  'app.agreementText': '协议正文',
  'app.uploadPdfExtract': '上传 PDF 提取文本',
  'app.fullPdfUpload': '完整 PDF 上传',
  'app.agreementPlaceholder': '点击此处开始编写协议正文...',
  'app.attachments': '附件',
  'app.attachmentsHint': '最多添加 10 个文件，总大小不超过 8 MB。',
  'app.addAttachment': '+ 添加附件',
  'app.signatureSection': '签名区域',
  'app.totalSignatures': '签名总数',
  'app.createNewField': '新建字段',
  'app.addField': '添加字段',
  'app.layout': '版式',
  'app.editLayout': '编辑版式',
  'app.addFieldTooltip': '在下方签名块中添加自定义字段（文本、日期、勾选框或签名）。新字段将出现在版式中，可通过“编辑版式”调整顺序或删除。最多 {{max}} 个自定义字段。',
  'app.date': '日期',
  'app.datePlaceholder': '年/月/日',
  'app.termsConditions': '条款与条件',
  'app.fullName': '姓名',
  'app.fullNamePlaceholder': '请输入完整姓名',
  'app.signature': '签名',
  'app.clickToSign': '点击签名',
  'app.termsAgree': '我同意全部条款与条件。',
  'app.phone': '电话',
  'app.phonePlaceholder': '请输入电话号码',
  'app.enterFieldPlaceholder': '请输入 {{label}}',
  'app.enterNumber': '请输入数字',
  'app.selectOption': '请选择...',
  'app.noFields': '暂无字段',
  'app.newDocument': '新建文档',
  'app.templateLabel': '模板：{{name}}',
  'app.forSubscribersOnly': '仅限订阅用户',
  'app.emailCredits': '邮件额度',
  'app.creditHintDeliver': '1 额度 = 1 次发送 — 点击发送即可投递',
  'app.skipAuthTesting': '跳过登录（测试用）',
  'app.agreementRequired': '请填写协议正文或上传 PDF。',
  'app.agreementOrPdfRequired': '需要协议正文或 PDF 文档。',
  'app.loadingPdf': '正在加载 PDF…',
  'app.clearConfirmTitle': '清空全部',
  'app.clearConfirmMessage': '确定要清空所有字段和附件吗？',
  'app.cancel': '取消',
  'app.clear': '清空',
  'app.clearConfirmButton': '确定，清空全部',
  'footer.tagline': '为现代用户提供的安全电子签名。',
  'footer.product': '产品',
  'footer.templates': '模板',
  'footer.company': '公司',
  'footer.contactSupport': '联系支持',
  'footer.copyright': '© 2026 primedocumentsign. 保留所有权利。',
  'footer.terms': '服务条款',
  'footer.privacy': '隐私政策',
  'auth.logIn': '登录',
  'auth.loggingIn': '登录中…',
  'auth.getStarted': '开始使用',
  'auth.signUp': '注册',
  'auth.logInToManage': '登录以管理和发送待签署文档。',
  'auth.startSending': '通过简单订阅计划开始发送文档。',
  'auth.termsConfirmStart': '我确认已阅读并同意',
  'auth.termsConfirmEnd': '。',
  'auth.termsMustAccept': '请接受服务条款后再创建账户。',
  'email.signSubject': '请签署此协议',
  'email.signTitle': '待签署文档',
  'email.signSubtitle': '您被请求签署一份文档',
  'email.fromLabel': '发件人',
  'email.signBody': '请点击下方按钮打开文档并添加签名。任何收件人均可使用此链接访问并签署，无需账户或订阅。',
  'email.signButton': '签署文档',
  'email.copyLink': '或复制此链接：',
  'email.ignoreNote': '如非您预期的邮件，可忽略。',
  'modal.editFieldLayout': '编辑字段版式',
  'modal.editFieldLayoutHint': '拖拽字段以调整顺序或在列之间移动。',
  'modal.columns': '列数',
  'modal.col': '{{n}} 列',
  'modal.addSpace': '添加空白',
  'modal.addField': '添加字段',
  'modal.fields': '字段',
  'modal.leftColumn': '左列',
  'modal.rightColumn': '右列',
  'modal.removeFromLayout': '将 {{name}} 从版式中移除？',
  'modal.space': '空白',
  'modal.yesRemove': '确定移除',
  'modal.keepIt': '保留',
  'modal.emptySpace': '空白区域',
  'modal.dropFieldsHere': '将字段拖放至此',
  'modal.removedFromLayout': '已从版式移除 — 点击 + 可恢复',
  'modal.saveLayout': '保存版式',
  'modal.removeFromLayoutTitle': '从版式移除',
  'modal.restoreToLayout': '恢复到版式',
  'modal.editCustomField': '编辑自定义字段',
  'modal.editCustomFieldHint': '修改标签、类型或哪些签署人可见此字段。',
  'modal.addCustomField': '添加自定义字段',
  'modal.addCustomFieldHint': '在签署表单中新建字段。最多 10 个自定义字段。',
  'modal.fieldLabel': '字段标签',
  'modal.fieldLabelPlaceholder': '如：公司名称',
  'modal.fieldType': '字段类型',
  'modal.displayContent': '显示内容（收件人只读，最多 100 字）',
  'modal.displayContentPlaceholder': '如：请阅读下方条款',
  'modal.picklistOptions': '下拉选项（最多 10 项）',
  'modal.typeAndPressAdd': '输入后按添加',
  'modal.add': '添加',
  'modal.addedToSignature': '已加入签名区',
  'modal.addedToSignatureHint': '勾选下方框以将新字段加入签名版式',
  'modal.signature1': '签名 1',
  'modal.signature2': '签名 2',
  'modal.close': '关闭',
  'modal.save': '保存',
  'modal.fieldLabelRequired': '请填写字段标签',
  'modal.displayContentRequired': '“显示文本”类型需填写显示内容',
  'modal.picklistOptionRequired': '请至少添加一项选项',
  'modal.selectOneSignature': '请至少选择一处签名',
  'modal.signingSectionExceed': '签名区将超过 {{limit}} KB 限制，请先删除部分内容。',
  'modal.link': '链接',
  'modal.linkTitle': '链接标题',
  'modal.linkUrl': '链接地址',
  'modal.linkTextPlaceholder': '链接文字',
  'modal.linkUrlPlaceholder': 'https://example.com',
  'modal.agreementSizeLimitReached': '协议大小已达上限',
  'modal.characterLimitReached': '字符数已达上限',
  'modal.agreementSizeLimitMessage': '协议大小已达上限（{{max}} KB）。请先删除部分内容或图片再继续添加。',
  'modal.characterLimitMessage': '字符数已达上限（{{max}} 字）。请先删除部分文字再继续添加。',
  'modal.signingSectionLimitReached': '签名区大小已达上限',
  'modal.signingSectionLimitMessage': '签名区大小已达上限（{{limit}} KB）。请删除部分字段值、签名或自定义字段后再添加。',
  'modal.ok': '确定',
  'modal.addYourSignature': '添加您的签名',
  'modal.signatureHint': '请使用鼠标或触控板签名。',
  'modal.clear': '清除',
  'modal.saveSignature': '保存签名',
  'modal.removeAttachment': '移除附件',
  'modal.removeAttachmentConfirm': '确定要从本文档中移除“{{name}}”吗？',
  'modal.yesRemoveLabel': '确定移除',
  'modal.removeLogo': '移除 logo',
  'modal.removeLogoConfirm': '确定要从本文档中移除 logo 吗？',
  'modal.textDisplay': '显示文本',
  'modal.picklist': '下拉选择',
  'modal.number': '数字',
  'modal.time': '时间',
  'modal.editLabel': '编辑标签',
  'modal.editField': '编辑字段',
  'modal.text': '文本',
  'modal.checkbox': '勾选框',
  'modal.date': '日期',
  'modal.signature': '签名',
  'modal.typeHasDataHint': '该字段已有数据，无法更改类型。',
  'modal.typeHasDataTitle': '字段有数据时无法更改类型',
  'modal.noKeepIt': '不，保留',
  'modal.yesDelete': '确定删除',
  'modal.deleteTemplate': '删除模板',
  'modal.deleteTemplateConfirm': '确定要删除“{{name}}”吗？此操作不可恢复。',
  'modal.removeAttachmentFromMessage': '确定要从邮件中移除“{{name}}”吗？',
  'modal.readyToSend': '确认发送？',
  'modal.recipientsLabel': '收件人：',
  'modal.readyToSendSubtitle': '您已预览文档并确认要发送吗？以下收件人将收到此邮件：',
  'modal.readyToSendNote': '下载 PDF 时：若间距设置不当，签名可能被裁切。请发送前检查并调整。',
  'modal.no': '否',
  'modal.yesSend': '是，发送',
  'modal.accountAlreadyExists': '账户已存在',
  'modal.accountAlreadyExistsMessage': '该邮箱已注册。是否登录或使用其他邮箱注册？',
  'modal.useDifferentEmail': '使用其他邮箱',
  'modal.logIn': '登录',
  'modal.logOut': '退出登录？',
  'modal.logOutSubtitle': '确定要退出登录吗？',
  'modal.yesLogOut': '是，退出',
  'lang.en': '英语',
  'lang.es': '西班牙语',
  'lang.pt': '葡萄牙语',
  'lang.ja': '日语',
  'lang.zh': '中文',
  'lang.hi': '印地语',
  'lang.fr': '法语',
  'lang.it': '意大利语',
  'lang.de': '德语',
  'lang.ar': '阿拉伯语',

  'templates.starter.nda.name': '保密协议（NDA）',
  'templates.starter.nda.scopeTitle': '保密协议',
  'templates.starter.freelance.name': '自由职业服务协议',
  'templates.starter.freelance.scopeTitle': '自由职业服务协议',
  'templates.starter.vehicle.name': '车辆销售协议',
  'templates.starter.vehicle.scopeTitle': '车辆销售协议',
  'templates.starter.rental.name': '住宅租赁协议',
  'templates.starter.rental.scopeTitle': '住宅租赁协议',
  'templates.starter.recruitment.name': '招聘服务协议',
  'templates.starter.recruitment.scopeTitle': '招聘服务协议',
  'templates.starter.loan.name': '贷款协议',
  'templates.starter.loan.scopeTitle': '贷款协议',
  'templates.starter.website.name': '网站开发协议',
  'templates.starter.website.scopeTitle': '网站开发协议',
  'templates.starter.roommate.name': '室友协议',
  'templates.starter.roommate.scopeTitle': '室友协议',
  'templates.starter.photography.name': '摄影服务协议',
  'templates.starter.photography.scopeTitle': '摄影服务协议',
  'templates.starter.shortterm-rental.name': '短期租赁协议',
  'templates.starter.shortterm-rental.scopeTitle': '短期租赁协议',
  'templates.starter.equipment-rental.name': '设备租赁协议',
  'templates.starter.equipment-rental.scopeTitle': '设备租赁协议',
  'templates.starter.independent-contractor.name': '独立承包商协议',
  'templates.starter.independent-contractor.scopeTitle': '独立承包商协议',
}
